const socials = [
  { label: "Instagram", img: "/img/contact-us/instagram.svg", url: "https://www.instagram.com/joinsoloconnect/" },
  { label: "Facebook", img: "/img/contact-us/facebook.svg", url: "https://www.facebook.com/profile.php?id=61585472053103" },
  { label: "WhatsApp", img: "/img/contact-us/whatsapp.svg", url: "https://wa.me/919311146657" },
  { label: "YouTube", img: "/img/contact-us/youtube.svg", url: "https://www.youtube.com/@soloconnect-travel" },
];

export default function SocialSection() {
  return (
    <section className="max-w-4xl mx-auto px-6 pb-24 text-center">
      <h2 className="text-3xl font-extrabold text-gray-900 mb-3">
        Contact with <span className="text-brand-600">Us</span>
      </h2>
      <p className="text-gray-500 mb-10">
        Follow us on social media for travel tips, updates and exciting
        offers.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-sm sm:max-w-2xl mx-auto">
        {socials.map(({ img, label, url }) => (
          <a
            key={label}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-white border border-gray-100 shadow-sm rounded-full px-6 py-3 hover:shadow-md transition-shadow cursor-pointer"
          >
            <img src={img} alt={label} className="w-5 h-5 object-contain" />
            <span className="text-sm font-medium text-gray-700">{label}</span>
          </a>
        ))}
      </div>
    </section>
  );
}